import React from "react"
import { RotateCw } from "styled-icons/feather"

import ConfirmModal from "./ConfirmModal"

// "single"/"series" confirm the (irreversible) regeneration; the "blocked" variants explain why
// an already-published post (or a series containing one) can no longer be regenerated.
export type RecreateVisualMode = "single" | "series" | "blockedPost" | "blockedSeries"

// confirmLabel null = blocked variant: informational, OK-only.
const MODAL_COPY: Record<RecreateVisualMode, { title: string; description: string; confirmLabel: string | null }> = {
  single: {
    title: "Recreate this visual?",
    description: "This removes the current visual and generates a new one - this cannot be undone.",
    confirmLabel: "Recreate visual",
  },
  series: {
    title: "Recreate the whole series?",
    description: "This post is part of a series. To keep the visuals consistent, all posts in the series are regenerated. This cannot be undone.",
    confirmLabel: "Recreate series",
  },
  blockedPost: {
    title: "Can't recreate this visual",
    description: "This post has already been published, so its visual can no longer be regenerated.",
    confirmLabel: null,
  },
  blockedSeries: {
    title: "Can't recreate this series",
    description: "Some posts in this series have already been published, so its visuals can no longer be regenerated.",
    confirmLabel: null,
  },
}

type RecreateVisualModalProps = {
  isOpen: boolean
  mode: RecreateVisualMode
  onConfirm: () => void
  onClose: () => void
}

const RecreateVisualModal: React.FC<RecreateVisualModalProps> = ({ isOpen, mode, onConfirm, onClose }) => {
  const { title, description, confirmLabel } = MODAL_COPY[mode]
  const isBlocked = confirmLabel === null

  return (
    <ConfirmModal
      modalName="recreate-visual-modal"
      isOpen={isOpen}
      title={title}
      description={description}
      icon={isBlocked ? <span className="icon-error-circle" /> : <RotateCw size={20} />}
      confirmLabel={confirmLabel ?? undefined}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  )
}

export default RecreateVisualModal
